module.exports = __webpack_public_path__ + "static/img/sec2-img03@m.59e81cf.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ezwel-renewal/sec2-img03@m.png
// module id = DZau
// module chunks = 0